/**
 * Client registry of design-type adapters. Record<DesignType, …>: a type added to DESIGN_TYPE_LIST
 * without an adapter here does not compile. Server registry: `./server.ts`.
 */
import type { DesignType } from '../shared';
import type { ClientDesignAdapter } from './contract';
import { bannerClient } from './banner';
import { skinClient } from './skin';

export const CLIENT_ADAPTERS: Record<DesignType, ClientDesignAdapter> = {
  banner: bannerClient,
  shield: bannerClient,
  skin: skinClient,
};
